import { v4 as uuidv4 } from 'uuid';
import {UATProject} from "../types/UATProject";

export const updateUATProjects = (project: UATProject): void => {
    const existingUATs = JSON.parse(localStorage.getItem("UAT") || "[]");
    localStorage.setItem("UAT", JSON.stringify([...existingUATs, project]));
}

export const fetchUATProject = (projectID: string): UATProject | undefined => {
    const uat = localStorage.getItem("UAT");
    if (uat) {
        const projects = JSON.parse(uat) as UATProject[];
        return projects.find(project => project.id === projectID);
    }
    return undefined;
}

export const newUUID = () => {
    return uuidv4();
}

export const allMarketplacesMap = () => {
    return [
        { label: "United States", value: "US" },
        { label: "Germany", value: "DE" },
        { label: "Japan", value: "JP" },
        { label: "United Kingdom", value: "GB" },
        { label: "France", value: "FR" },
        { label: "Spain", value: "ES" },
        { label: "India", value: "IN" },
        { label: "Canada", value: "CA" },
        { label: "Netherlands", value: "NL" },
        { label: "Italy", value: "IT" },
        { label: "Australia", value: "AU" },
        { label: "Poland", value: "PL" },
        { label: "Sweden", value: "SE" },
        { label: "Belgium", value: "BE" },
        { label: "Turkey", value: "TR" },
        { label: "Mexico", value: "MX" },
        { label: "Brazil", value: "BR" },
        { label: "Argentina", value: "AR" },
        { label: "Chile", value: "CL" },
        { label: "Colombia", value: "CO" },
        { label: "Costa Rica", value: "CR" },
        { label: "Dominican Republic", value: "DO" },
        { label: "Guatemala", value: "GT" },
        { label: "Paraguay", value: "PY" },
        { label: "Peru", value: "PE" },
        { label: "Denmark", value: "DK" },
        { label: "Finland", value: "FI" },
        { label: "Norway", value: "NO" },
        { label: "Portugal", value: "PT" },
        { label: "South Africa", value: "ZA" },
        { label: "Nigeria", value: "NG" },
        { label: "Kenya", value: "KE" },
        { label: "Czech Republic", value: "CZ" },
        { label: "Hungary", value: "HU" },
        { label: "Iceland", value: "IS" },
        { label: "Ireland", value: "IE" },
        { label: "Romania", value: "RO" },
        { label: "Switzerland", value: "CH" },
        { label: "Indonesia", value: "ID" },
        { label: "Malaysia", value: "MY" },
        { label: "New Zealand", value: "NZ" },
        { label: "Philippines", value: "PH" },
        { label: "Taiwan", value: "TW" }
    ];

}